import React, { type InputHTMLAttributes } from 'react';

import { IconCheck } from '@pkg/assets/icons';

import './Checkbox.scss';

interface YatCheckBoxProps extends InputHTMLAttributes<HTMLInputElement> {
    children?: React.ReactNode;
    wrapperClass?: string;
}

export const Checkbox = ({ children, wrapperClass = '', ...props }: YatCheckBoxProps) => {
    return (
        <label htmlFor={props.id} className={`yat-checkbox ${wrapperClass}`}>
            <span className="yat-checkbox__input">
                <input type="checkbox" {...props} />
                <span className="yat-checkbox__control" aria-hidden="true">
                    <IconCheck />
                </span>
            </span>
            {children && <span className="yat-checkbox__label">{children}</span>}
        </label>
    );
};
